import React from 'react'
import Slider from 'lib/ui/Slider'
import {Controller, UseFormMethods} from 'react-hook-form'
import {Label} from 'lib/ui/typography'
import ColorPicker from 'lib/ui/ColorPicker'
import FontSelect from 'lib/FontSelect'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'
import {DEFAULT_BUTTON_TEXT_COLOR} from 'lib/ui/Button/CustomButton'
import {CAPS} from 'lib/ui/typography/FontStyleInput'
import {WidgetButton} from 'organization/Event/WidgetConfig/ButtonStylesConfig/WidgetButton'

const DEFAULT_FONT_SIZE = 16

export default function TypographySection(props: {
  control: UseFormMethods['control']
  button: WidgetButton
  storageKey: string
  disableColors?: boolean
  label: string
  visible?: boolean
}) {
  const {control, button, disableColors, label, visible = true} = props

  if (!visible) {
    return null
  }

  return (
    <CollapsibleSection label={label} storageKey={props.storageKey}>
      <Label>Font</Label>
      <Controller
        control={control}
        name="font"
        defaultValue={{
          family: button.font?.family || 'inherit',
          variants: button.font?.variants || [],
          styles: button.font?.styles || [CAPS],
        }}
        render={({value, onChange}) => (
          <FontSelect value={value} onChange={onChange} />
        )}
      />
      <Controller
        name="fontSize"
        defaultValue={button.fontSize || DEFAULT_FONT_SIZE}
        control={control}
        render={({value, onChange}) => (
          <Slider
            min={1}
            max={100}
            onChange={onChange}
            valueLabelDisplay="off"
            value={value}
            label="Font Size"
          />
        )}
      />
      <ColorPickers
        control={control}
        button={button}
        disabled={disableColors}
      />
    </CollapsibleSection>
  )
}

function ColorPickers(props: {
  control: UseFormMethods['control']
  button: WidgetButton
  disabled?: boolean
}) {
  const {control, button, disabled} = props

  if (disabled) {
    return null
  }

  return (
    <>
      <Controller
        name="textColor"
        control={control}
        defaultValue={button.textColor || DEFAULT_BUTTON_TEXT_COLOR}
        render={({value, onChange}) => (
          <ColorPicker label="Text Color" color={value} onPick={onChange} />
        )}
      />
      <Controller
        name="hoverTextColor"
        control={control}
        defaultValue={button.hoverTextColor || DEFAULT_BUTTON_TEXT_COLOR}
        render={({value, onChange}) => (
          <ColorPicker
            label="Text Hover Color"
            color={value}
            onPick={onChange}
            aria-label="text hover color"
          />
        )}
      />
    </>
  )
}
